module.exports = __webpack_public_path__ + "img/icon-modular.c039cbc3.svg";